export default "__VITE_ASSET__CuJ1onyK__"